import {Package} from './Package';
import {Product} from './Product';
import {OrderItemProductPackageProduct} from './OrderItemProductPackageProduct';

export class OrderItemProductPackage {
  public id: number;
  public package: number|any;
  public orderItemProductPackageProducts: OrderItemProductPackageProduct[] = [new OrderItemProductPackageProduct()];
  public products: Product[];
  public packageObj: Package;

}
